import React from 'react';

const AcercaDeSit = ({ isOpen, onClose }) => {
  if (!isOpen) return null; // No renderiza nada si el modal está cerrado

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full mx-4 sm:mx-6 max-h-[80vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Acerca de SIT</h2>
          <button
            onClick={onClose}
            className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Contenido */}
        <div className="p-6 text-gray-800 dark:text-gray-100">
          <p className="mb-4 font-semibold text-lg">
            Social Interactive Technology – Tu plataforma digital para conectar, compartir y crecer en la comunidad universitaria.
          </p>

          <section className="mb-6">
            <h2 className="text-xl font-bold text-teal-600 mb-2">¿Qué es SIT?</h2>
            <p className="text-sm sm:text-base">
              SIT (Social Interactive Technology) es una plataforma digital diseñada para estudiantes universitarios. Inspirada en herramientas modernas de interacción, SIT busca transformar la experiencia universitaria al ofrecer un espacio integral donde puedes comunicarte, colaborar y desarrollar tus proyectos académicos y profesionales.
            </p>
            <p className="text-sm sm:text-base mt-2">
              Nuestra misión es <strong>fortalecer la comunidad estudiantil</strong> mediante herramientas innovadoras que faciliten la comunicación, promuevan la colaboración y apoyen el emprendimiento en un entorno seguro, intuitivo y dinámico.
            </p>
          </section>

          <section className="mb-6">
            <h2 className="text-xl font-bold text-teal-600 mb-2">Funcionalidades clave</h2>
            <ul className="list-disc pl-5 text-sm sm:text-base">
              <li className="mb-2"><strong>Publicaciones y Feed Dinámico:</strong> Comparte publicaciones cortas con toda la comunidad universitaria o por carrera.</li>
              <li className="mb-2"><strong>Perfiles Personalizados:</strong> Crea un perfil único para mostrar tu información académica y profesional.</li>
              <li className="mb-2"><strong>Chat Integrado:</strong> Comunícate en tiempo real con otros estudiantes en un entorno seguro.</li>
              <li className="mb-2"><strong>Market-SIT:</strong> Marketplace universitario para comprar y vender artículos y servicios.</li>
              <li><strong>Interfaz Intuitiva y Segura:</strong> Plataforma fácil de usar y diseñada para proteger tu privacidad.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-xl font-bold text-teal-600 mb-2">Nuestra visión</h2>
            <p className="text-sm sm:text-base">
              SIT aspira a ser el <strong>centro digital de la vida universitaria</strong>, un lugar donde los estudiantes puedan:
            </p>
            <ul className="list-disc pl-5 text-sm sm:text-base">
              <li><strong>Conectar:</strong> Romper barreras de comunicación entre estudiantes de nuevo ingreso y experimentados.</li>
              <li><strong>Colaborar:</strong> Fomentar el intercambio de conocimientos, ideas y recursos académicos.</li>
              <li><strong>Crecer:</strong> Impulsar el desarrollo profesional y los emprendimientos estudiantiles en un entorno confiable.</li>
            </ul>
          </section>

          <section className="mb-6">
            <h2 className="text-xl font-bold text-teal-600 mb-2">¿Por qué SIT?</h2>
            <p className="text-sm sm:text-base">
              Los estudiantes universitarios merecen un espacio digital que refleje sus necesidades. SIT aborda desafíos como la desinformación, la falta de integración y la dificultad para emprender, ofreciendo una solución moderna y centralizada:
            </p>
            <ul className="list-disc pl-5 text-sm sm:text-base">
              <li><strong>Para nuevos estudiantes:</strong> Encuentra orientación y conecta con compañeros.</li>
              <li><strong>Para emprendedores:</strong> Promociona tus productos o servicios a una audiencia estudiantil.</li>
              <li><strong>Para todos:</strong> Participa en una comunidad vibrante y forma parte del cambio universitario.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-teal-600 mb-2">¡Únete a SIT!</h2>
            <p className="text-sm sm:text-base">
              Transforma tu experiencia universitaria con SIT. Conecta, crea, colabora y deja tu huella en la comunidad.
            </p>
            <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mt-2">
              *SIT es un proyecto en constante crecimiento, orientado a estudiantes universitarios. Próximamente, nuevas funcionalidades y expansiones.*
            </p>
          </section>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcercaDeSit;
